import { useEffect } from "preact/compat"
import { useLocation } from "wouter-preact"
import { clearUser } from "./user"
import { safeExec } from "@/utils"

export function Logout() {
  const [, setLocation] = useLocation()

  useEffect(() =>
    safeExec(async () => {
      await fetch("/api/auth/signout", { method: "GET" })
      // todo: this isn't actually working?
      clearUser()
      setLocation("/")
    }), [])

  return <div></div>
}
